/* eslint-disable @typescript-eslint/camelcase */

import * as Rox from "rox-browser";
import { BcsFlag, FcsFlag } from "../unleash";

const RoxPermissionPickup = {};

const fcsFlagsPickup = {
    permission_pickup_scheduled_pickup_enable: new FcsFlag.Flag(false),
    permission_pickup_scheduled_pickup_create: new FcsFlag.Flag(false),
    permission_pickup_scheduled_pickup_edit: new FcsFlag.Flag(false),
    permission_pickup_enable: new FcsFlag.Flag(false),
    permission_pickup_list_pickup_create: new FcsFlag.Flag(false),
    permission_pickup_list_pickup_edit: new FcsFlag.Flag(false),
    permission_pickup_list_pickup_cancel: new FcsFlag.Flag(false),
    permission_pickup_enable_v2: new FcsFlag.Flag(false)
};

const BcsPermissionPickup = {
  pickup_corporate_config: new BcsFlag.JSONFlag({
    start_hour: 8,
    end_hour: 23,
    lead_time_hours: 4,
    armada_threshold_kg: 20
  })
};

export const FlagsPermissionPickup = {
  ...RoxPermissionPickup,
  ...fcsFlagsPickup,
  ...BcsPermissionPickup
};

export function initFlagsPermissionPickup() {
  Rox.register("featurePickup", RoxPermissionPickup);
  FcsFlag.register("featurePickup", fcsFlagsPickup);
  BcsFlag.register("featurePickup", BcsPermissionPickup);
}
